import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@/components/ui/tooltip";

/**
 * A small "?" icon that reveals a short explainer on hover/focus.
 * Use liberally next to non-obvious labels: pricing rules, commission math,
 * status pills, catalog counts, etc. Keep the copy under ~200 chars.
 *
 * Usage:
 *   <span className="flex items-center gap-1.5">
 *     Setup share <HelpTip text="Rep gets 50% of every $1,499 setup fee." />
 *   </span>
 */
export function HelpTip({ text, side = "top", size = 12, testId }) {
  if (!text) return null;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center justify-center text-ink-muted hover:text-ink cursor-help transition-colors align-middle"
            aria-label="More information"
            data-testid={testId}
            tabIndex={0}
          >
            <HelpCircle size={size} />
          </span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-[280px] bg-bg-surface border border-line text-ink text-[12px] leading-relaxed py-2 px-3 shadow-lg rounded-sm"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
